import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e377a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-header material-card_type_outlined" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-header__avatar" }, null, -1))
const _hoisted_3 = { class: "user-header__data" }
const _hoisted_4 = { class: "user-header__name" }
const _hoisted_5 = {
  key: 0,
  class: "user-header__subheader"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "user-header__subheader-text" }


import { IUserHeaderProps } from './user-header.types';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'user-header',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.props.name) + " " + _toDisplayString(__props.props.surname), 1),
      (__props.props.subheader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (__props.props.subheaderIcon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: `${_unref(getBaseUrl)()}${__props.props.subheaderIcon}`,
                  alt: "",
                  class: "user-header__subheader-icon"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.props.subheader), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})